<template>
    <div >
        <el-tabs type="border-card">
            <el-tab-pane v-for="(item,index) in weekList" >
                <div slot="label" @click="tabclick(item,index)">
                    <div align="center" style="padding: 10px 10px 0 10px">{{item.day}}</div>
                    <div align="center" style="padding: 10px ">{{item.week}}</div>
                </div>
                <el-form :model="item.formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">

                    <el-form-item class="form-title" prop="tableData" >
                        <el-table
                                @row-click="selectItem"
                                ref="baseForm"
                                border
                                :data="item.formData.tableData"
                                style="width: 100%;max-height: 350px;overflow: auto;min-width: 940px">
                            <template slot="empty">
                                <span @click="addRow(item)" v-if="editData1.state!=1">点击添加菜品</span>
                            </template>
                            <el-table-column
                                    type="index"
                                    width="40">
                            </el-table-column>

                            <el-table-column
                                    prop="name"
                                    label="菜品名称"
                                    width="160"
                            >
                                <template slot-scope="scope">
                                    <el-form-item >
                                        <el-input
                                                :disabled="scope.row.allfoods.length==1||editData1.state==1||scope.row.allfoods.length==0"
                                                type="text"
                                                placeholder="请输入菜品名称"
                                                v-model="scope.row.foodName"
                                                clearable
                                        >
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    min-width="160"
                                    label="菜品选择"
                            >
                                <template slot-scope="scope">
                                    <el-form-item :prop="'tableData.' + scope.$index + '.allfoods'" :rules="formRules.allfoods" class="ceshic">
                                        <!--                                            {{scope.row.allfoods}}-->
                                        <el-select @focus="treeIndex(scope.$index,scope.row,index)" v-model="scope.row.allfoods"
                                                   @change="cpchange1"
                                                   :filter-method="e=>cpchange(e,scope.$index,index)"
                                                   clearable multiple filterable
                                                   :ref="'treeinput'+(scope.$index+index)" placeholder="请选择菜品"
                                                   @remove-tag="cpremove(scope.$index,scope.row,$event,item,index)"
                                                   @clear="cpclear(scope.row,scope.$index,index)" style="width: 100%"
                                                   :disabled="editData1.state==1">
                                            <el-option
                                                    :key="scope.$index"
                                                    :value="scope.row.allfoods"
                                                    style="height: auto">
                                                <el-tree
                                                        id="tree-option"
                                                        :data="cpdata"
                                                        show-checkbox
                                                        :draggable="false"
                                                        default-expand-all
                                                        node-key="id"
                                                        @node-drag-over="ceshi"
                                                        :ref="'tree'+(scope.$index+index)"
                                                        highlight-current
                                                        :default-checked-keys="scope.row.oldfoodid"
                                                        :filter-node-method="filterNode"
                                                        :props="defaultProps"
                                                        @check="handleCheckChange(scope.row,arguments)"
                                                        @check-change="checkchange(scope.row,scope.$index,arguments,item)"
                                                >
                                                </el-tree>
                                            </el-option>

                                        </el-select>

                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="原价(元)"
                                    width="90"
                            >
                                <template slot-scope="scope">
                                    <el-form-item :prop="'tableData.' + scope.$index + '.price'" :rules="formRules.price">
                                        <el-input
                                                disabled
                                                type="text"
                                                placeholder="请输入原价"
                                                v-model="scope.row.price"
                                                clearable
                                        >
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="售价(元)"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <el-form-item :prop="'tableData.' + scope.$index + '.disPrice'" :rules="formRules.disPrice">
                                        <el-input
                                                oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
                                                @blur="scope.row.disPrice=$event.target.value"
                                                type="text"
                                                placeholder="请输入售价"
                                                v-model="scope.row.disPrice"
                                                clearable
                                                :disabled="editData1.state==1"
                                        >
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="总量(份)"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <el-form-item >
                                        <el-input
                                                oninput="value=value.replace(/[^-0-9]/g,'')"
                                                :disabled="editData1.state==1"
                                                type="text"
                                                placeholder="请输入总量"
                                                v-model.number="scope.row.qtyControl"
                                                clearable
                                        >
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="剩余量(份)"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <el-form-item >
                                        <el-input
                                                disabled
                                                type="text"
                                                placeholder="剩余量"
                                                v-model.number="scope.row.remainQty"
                                                clearable
                                        >
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="退单时效(h)"
                                    width="100"
                            >
                                <template slot-scope="scope">
                                    <el-form-item >
                                        <el-input
                                                :disabled="editData1.state==1"
                                                oninput="value=value.replace(/[^0-9]/g,'')"
                                                type="text"
                                                placeholder="退单时效"
                                                v-model.number="scope.row.refundTimeout"
                                                clearable
                                        >
                                        </el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="餐别"
                            >
                                <template slot-scope="scope">
                                    <el-form-item :prop="'tableData.' + scope.$index + '.catering'" :rules="formRules.catering">
<!--                                                 {{scope.row.catering}}-->
                                        <!--                                                   @change="cbchange1(scope.row,scope.$index,arguments,item)"-->

                                        <el-select v-model="scope.row.catering" @focus="cbChange"
                                                   clearable multiple filterable :disabled="editData1.state==1" placeholder="请选择餐别">
                                            <el-option
                                                    v-for="item in cbdata"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="title=='菜谱发布'?item.id:item.name">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="食堂"
                            >
                                <template slot-scope="scope">
                                    <el-form-item :prop="'tableData.' + scope.$index + '.canteen'" :rules="formRules.canteen">
                                        <!--                                            {{scope.row.canteen}}-->
                                        <el-select v-model="scope.row.canteen" @focus="stChange" :disabled="editData1.state==1"
                                                   clearable multiple filterable placeholder="请选择食堂">
                                            <el-option
                                                    v-for="item in ctdata"
                                                    :key="item.canteen"
                                                    :label="item.canteenName"
                                                    :value="title=='菜谱发布'?item.canteen:item.canteenName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-plus" @click="addLine(item)" :disabled="editShow" v-if="editData1.state==0||editbtn==2"></el-button>
                                    <el-button type="text" icon="el-icon-minus" v-if="editData1.state==0||editbtn==2"  @click.native.prevent="deleteRow(scope.$index, formData.tableData,scope.row,item)"
                                               :disabled="editData1.state==1"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    <el-form-item class="lable-width" style="margin-left: 0">
                        <el-button style="margin-left: 0" type="primary" @click="onSubmit" :disabled="isDisable||editShow||editData1.state==1" >{{$t('button_save')}}</el-button>
                        <el-button type="primary" @click="close">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";

    export default {
        name: 'addMenu',
        props:{
            editbtn:{
                type:Number
            },
            editData1:{
                type:Object
            },
            editShow1:{
                type:Boolean
            },
            dateList:{
                type:Array
            },
            title:{
                type:String
            },
            moren:{
                type:String
            }
        },
        data(){
            return{

                formData:{
                    createTime:'',
                    tableData:[],
                },
                shibai:1,
                timeDefaultShow:'',
                cpdata:[],
                pickerOptions:{
                    disabledDate(time){
                        return time.getTime()<Date.now()
                    }
                },
                delall:[],
                cbdata:{},
                ctdata:{},
                treeindex:0,
                index:0,
                // showForm:false,
                editShow:this.editShow1,
                formRules:{
                    // foodName: [
                    //     { required: true, message: '请输入菜品名称', trigger: 'blur' }
                    // ],
                    // disPrice:[
                    //     {required: true, message: '请输入售价', trigger: 'blur' },
                    //     // {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入数字", trigger: "blur" },
                    //     // {pattern: /^\d+(\.\d{1,2})?$/, message: "请保留两位小数", trigger: "blur" }
                    // ],
                    // catering:[
                    //     { required: true, message: '请选择餐别', trigger: 'change' }
                    // ],
                    // allfoods:[
                    //     {required: true, message: '请选择菜品', trigger: 'change' }
                    // ],
                    // canteen:[
                    //     {required: true, message: '请选择餐厅', trigger: 'change' }
                    // ],
                },
                delId:0,
                isDisable:false,
                cpShow:this.title=='菜谱发布'?false:true,
                defaultProps: {
                    children: "foodList",
                    label: "foodName",
                },
                oldTable:[],
                deldata:[],
                weekList:[],
                oldEdit:[],
                moren1:''
            }
        },
        watch:{

        },
        mounted(){
            this.moren1=JSON.parse(JSON.stringify(this.moren))
            this.getDate()
            this.getDataDict()
            this.getCanteenList()
            this.getFoodList()

            // this.getFoodList()
            // this.getCanteenList()
            // this.getDataDict()
            // console.log(this.editData1)
            if(!!this.editData1.week){
                let b=[]
                for(let i =-6;i<0;i++){
                    b.push(this.getdate(i,this.editData1.datePeriod.substring(0,10)))

                }
                b.push(this.editData1.datePeriod.substring(0,10))

                // console.log(b)
                b=b.reverse()//反转数组顺序
                // console.log(b)
                b.forEach(item=>{
                    this.weekList.push({
                        week:'',
                        day:item
                    })
                })
                // console.log(this.weekList)
                let days = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

                this.weekList.map(item=>{
                    // console.log(new Date(item.day).getDay())
                    item.week=days[new Date(item.day).getDay()]
                    this.$set(item,'formData',{tableData:[]})
                })
                this.oldEdit.push(this.editData1.datePeriod.substring(0,10))
                this.menuDetail(this.editData1.datePeriod.substring(0,10))

            }else{
                var now = new Date();
                var nowTime = now.getTime() ;
                var day = now.getDay()|| 7;// 不加 || 7.周末会变成下周一
                var oneDayTime = 24*60*60*1000 ;
                var SundayTime =  nowTime + (7-day)*oneDayTime ;//显示周日
                //调用方法
                // console.log(this.formatDate(new Date(MondayTime))),
                let a=this.formatDate(new Date(SundayTime))
                let b=[]
                for(let i =-7;i<0;i++){
                    b.push(this.getdate(i,a))

                }
                b=b.reverse()
                // console.log(b)
                b.forEach(item=>{
                    this.weekList.push({
                        week:'',
                        day:item
                    })
                })
                // console.log(this.weekList)
                let days = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

                this.weekList.map(item=>{
                    // console.log(new Date(item.day).getDay())
                    item.week=days[new Date(item.day).getDay()]
                    this.$set(item,'formData',{tableData:[]})
                })
            }

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            ceshi(e){
            },
            // dateChange(val){
            //     // console.log(this.dateList.includes(val))
            //     if(this.dateList.includes(val)){
            //         this.$message.error("该日已新增菜谱，若增加菜品请编辑该日菜谱。")
            //         this.formData.createTime=''
            //     }
            // },
            tabclick(item,index){
                // console.log(this.oldEdit.includes(item.day))
                // console.log("tabitem",item)
                if(!this.oldEdit.includes(item.day)&&this.editbtn==3){
                    this.oldEdit.push(item.day)//将选择的日期赋值给oldEdit
                    this.menuDetail(item.day)
                    // console.log(1)
                }
            },
            //格式化日期：yyyy-MM-dd
            //菜谱详情
            async menuDetail(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    date:val
                }
                let res = await API.getDetail(params);
                if (res.code == 1) {


                    this.weekList.map((item,index)=>{

                        if(item.day==val){

                            // let tab =res.data;//将详情赋值的obj传给id
                            // tab.map((ta=>{
                            //     ta.foodsInfo.map((t=>{
                            //         t.id=t.obj
                            //     }))
                            //
                            // }));
                            // console.log('tab',tab)
                            // this.weekList[index].formData.tableData=tab;
                            this.weekList[index].formData.tableData=res.data;
                            // console.log('详情',this.weekList[index].formData.tableData)
                            this.weekList[index].formData.tableData.map(re=>{
                                re.price = re.originalPrice//售价赋值给原价
                            });
                            item.formData.tableData.map(it=>{
                                this.$set(it,'foodsid',[])//所有菜品id
                                this.$set(it,'allfoods',[])//菜品名
                                this.$set(it,'oldfoodid',[])
                            })
                            this.$set(item.formData,'alloldid',[])
                            if(item.formData.tableData.length!=0){
                                item.formData.tableData.map(itt=>{
                                    this.$set(itt,'foods',[])//菜品信息
                                    this.$set(itt,'editfoods',[])//菜品信息
                                    itt.foodsInfo.map(ittt=>{
                                        itt.foodsid.push(ittt.obj)
                                        itt.allfoods.push(ittt.foodName)
                                        itt.oldfoodid.push(ittt.obj)

                                        itt.foods.push({
                                            id:ittt.id,
                                            obj:ittt.obj,
                                            foodName:ittt.foodName,
                                            price:ittt.price,
                                            foodType:ittt.foodType,
                                        })
                                        itt.editfoods.push({
                                            id:ittt.obj,
                                            foodName:ittt.foodName,
                                            price:ittt.price,
                                            foodType:ittt.foodType,
                                        })
                                    })

                                    this.$set(itt,'allcanteens',[])
                                    this.$set(itt,'allcaterings',[])
                                    // console.log("itt",itt)
                                    itt.canteen.map(cat=>{
                                        itt.allcanteens.push({
                                            id:cat.id,
                                            obj:cat.obj,
                                            name:cat.name,
                                            pid:cat.pid
                                        })
                                        // cat.id = cat.obj
                                    })
                                    itt.canteen=[]
                                    itt.allcanteens.map(can=>{
                                        itt.canteen.push(can.name)
                                    })
                                    itt.catering.map(cat=>{
                                        itt.allcaterings.push({
                                            id:cat.id,
                                            name:cat.name,
                                            obj:cat.obj,
                                            pid:cat.pid
                                        })
                                    })
                                    itt.catering=[]
                                    itt.allcaterings.map(allcat=>{
                                        itt.catering.push(allcat.name)
                                        // can.id = can.obj
                                    })
                                    // this.getDataDict()
                                    // console.log("itt",itt)
                                })
                                item.formData.tableData.map(idd=>{
                                    item.formData.alloldid=[...item.formData.alloldid,...idd.oldfoodid]
                                })
                                this.oldTable.push(JSON.parse(JSON.stringify(item)))//修改前的table

                            }
                        }

                    })
                    // console.log('weekList',this.weekList)





                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            formatDate(date) {
                var myyear = date.getFullYear();
                var mymonth = date.getMonth() + 1;
                var myweekday = date.getDate();

                if (mymonth < 10) {
                    mymonth = "0" + mymonth;
                }
                if (myweekday < 10) {
                    myweekday = "0" + myweekday;
                }
                return (myyear + "-" + mymonth + "-" + myweekday);
            },
            getdate(num,time){
                let n=num
                let d=''
                if(time){
                    d=new Date(time)
                }else{
                    d=new Date()
                }
                let year =d.getFullYear()
                let mon=d.getMonth()+1
                let day=d.getDate()
                if(day<=n){
                    if(mon>1){
                        mon=mon-1
                    }else{
                        year=year-1
                        mon=12
                    }
                }
                d.setDate(d.getDate()-n)
                year =d.getFullYear()
                mon=d.getMonth()+1
                day=d.getDate()
                let s=year+'-'+(mon<10?('0'+mon):mon)+'-'+(day<10?('0'+day):day)
                return s
            },

            cbChange(){

            },
            stChange(){
            },
            getDate(){
                var date = new Date();
                var year = date.getFullYear(); //月份从0~11，所以加一
                let month = date.getMonth();
                // console.log("month",month);
                var dateArr = [
                    date.getMonth() + 1,
                    date.getDate(),

                ];
                for (var i = 0; i < dateArr.length; i++) {
                    if (dateArr[i] >= 1 && dateArr[i] <= 9) {
                        dateArr[i] = "0" + dateArr[i];
                    }
                }
                var strDate =
                    year +
                    "/" +
                    dateArr[0] +
                    "/" +
                    dateArr[1] ;
                // console.log(strDate);
                this.timeDefaultShow=strDate
            },
            close(){
                this.$emit('close')
            },
            selectItem(row, column, event) {

            },
            addRow(item){
                this.addLine(item)
                // this.formData.tableData=this.tableData
            },
            addLine (item) {
                // console.log(item)
                const newLine = {
                    id:0,
                    price:0,
                    pid:0,//主表id
                    disPrice:0,
                    foods:[],
                    refundTimeout:this.moren1,
                    editfoods:[],
                    catering:[],
                    allcaterings:[],
                    allcanteens:[],
                    foodsInfo:[],
                    allfoods:[],
                    canteen:[],
                    index:this.index,
                    delCookBook:[],
                    foodsid:[],
                    oldfoodid:[],
                    qtyControl:-1,
                    remainQty:0,
                }
                this.index++
                item.formData.tableData.push(newLine)
            },
            // 删除指定行
            deleteRow(index, rows,val,item) {
                this.delId=1
                if(!!item.formData.tableData[index].id){
                    this.delall.push(item.formData.tableData[index].id)
                    this.deldata.push(item.formData.tableData[index])
                }
                item.formData.tableData.splice(index,1)
            },
            cpchange1(e){
               e.forEach((item,index)=>{
                   if(Array.isArray(item)){
                       e.splice(index,1)
                   }
               })
                // this.getFoodList()
            },
            treeIndex(i,e,index){
                let ref = eval("this.$refs.tree" + (i + index))[0]//获取tree
                e.allfoods.forEach(item=>{
                    ref.setChecked(item,true)

                })
                this.delId=0
                this.treeindex=i
                this.cpShow=true
            },
            checkchange(item,i,data,it){
                //item:行数据；i:行index；data:data[0]选中或取消的菜品，data[1]:true选中/false；it:该天所有信息
                // console.log('checkchange')
                // console.log("item",item)
                // console.log(data,'data')
                // console.log(it,'it')
                if(this.delId==0){
                    if(!data[0].foodList&&data[1]){//选中
                        item.allfoods.push(data[0].foodName)//传选中的菜品名
                        item.foods.push(data[0])//传选中的菜品信息
                        item.editfoods.push(data[0])//传选中的菜品信息
                        item.foodsid.push(data[0].id)//选中的菜品名id
                        item.oldfoodid.push(data[0].id)//将选中的菜品id赋值给多选框
                        // console.log(item.oldfoodid)
                        let a=[]//存价格
                        item.foods.map(it=>{
                            a.push(it.price)
                        })
                        item.price=0
                        a.forEach(i=>{
                            item.price=this.xsadd(item.price,i)
                        })
                        item.disPrice=item.price
                        if(item.allfoods.length==1){
                            this.$set(it.formData.tableData[i],'foodName',item.allfoods[0])

                            // it.formData.tableData[i].foodName=item.allfoods[0]
                        }else{
                            this.$set(it.formData.tableData[i],'foodName','')

                            // it.formData.tableData[i].foodName=''
                        }
                    }else if(!data[0].foodList&&!data[1]){//取消
                        // console.log("old1",item.oldfoodid)
                        item.allfoods.map((it,index)=>{
                            if(data[0].foodName==it){
                                item.allfoods.splice(index,1)
                            }
                        })
                        item.foodsid.map((it,index)=>{
                            if(data[0].id==it){
                                item.foodsid.splice(index,1)
                            }
                        })
                        // console.log("item.foodsid",item.foodsid)
                        item.foods.map((it,index)=>{
                            if(data[0].id==it.id){
                                item.foods.splice(index,1)
                            }
                        })
                        item.editfoods.map((it,index)=>{
                            if(data[0].id==it.id){
                                item.editfoods.splice(index,1)
                            }
                        })
                        item.oldfoodid.map((it,index)=>{
                            if(data[0].id==it){
                                item.oldfoodid.splice(index,1)
                            }
                        })
                        // console.log(item.oldfoodid)
                        let a=[]
                        item.foods.map(it=>{
                            a.push(it.price)
                        })
                        item.price=0
                        a.forEach(i=>{
                            //item.price=item.price+i
                            item.price=this.xsadd(item.price,i)
                        })
                        item.disPrice=item.price
                        if(item.allfoods.length==1){
                            this.$set(it.formData.tableData[i],'foodName',item.allfoods[0])
                            // it.formData.tableData[i].foodName=item.allfoods[0]
                        }else{
                            this.$set(it.formData.tableData[i],'foodName','')
                            // it.formData.tableData[i].foodName=''
                        }
                        // console.log("fl",item.foodsid)
                        if(item.foodsid.length==0){
                            item.oldfoodid=[]
                            // console.log("old1",item.oldfoodid)
                        }
                        // console.log("old2",item.oldfoodid)
                    }
                }


            },
            handleCheckChange(item,data){
                // item.disPrice=item.price

            },
            cpremove(i,e,name,item,index){
                //i:该行index，e:该行数据，name:删除的食物名，item:该日数据，index:该日index
                // console.log(i)
                // console.log('row',e)
                // console.log('name',name)
                // console.log('item',item)
                // console.log("index",index)
                // return
                let ref1 = eval("this.$refs.treeinput" + (i + index))[0]//获取select框
                let ref = eval("this.$refs.tree" + (i + index))[0]//获取tree
                // console.log(ref1)
                //  ref1.focus()//select框获取焦点
                item.formData.tableData[i].foods.map((it,sindex)=>{//循环foods
                    // console.log("treei",this.treeindex)
                    // console.log("i",i)
                    // if(it.foodName==name&&this.treeindex==i){//判断foods中foodName等于要删除的菜品名并且判断tree的下标等于该行下标
                        // console.log(item.formData.tableData[i].foods[sindex])
                        ref1.focus()
                    if(!!item.formData.tableData[i].editfoods[sindex]){
                        if(item.formData.tableData[i].editfoods[sindex].foodName==name){

                            ref.setChecked(item.formData.tableData[i].editfoods[sindex],false)//调用setChecked方法取消选中tree里面对应的菜品信息
                        }
                    }

                        item.formData.tableData[i].price=(item.formData.tableData[i].price-it.price).toFixed(2)//减去删除菜品的价格
                        // item.formData.tableData[i].allfoods.splice(sindex,1)
                        // item.formData.tableData[i].foods.splice(sindex,1)//删除foods中该条菜品信息
                        // item.formData.tableData[i].editfoods.splice(sindex,1)//删除foods中该条菜品信息
                        // item.formData.tableData[i].foodsid.splice(sindex,1)//删除foodsid中该条菜品id
                        // item.formData.tableData[i].oldfoodid.splice(sindex,1)//删除oldfoodid中该条菜品id


                            item.formData.tableData[i].disPrice=item.formData.tableData[i].price//将原价赋值给售价
                            // item.formData.tableData[i].disPrice=item.formData.tableData[i].price
                            if(item.formData.tableData[i].allfoods.length==1){//判断allfoods里数据是否为一条
                                this.$set(item.formData.tableData[i],'foodName',item.formData.tableData[i].allfoods[0])//如果allfoods中的数据为一条，将该条数据赋值给foodName
                                // it.formData.tableData[i].foodName=item.allfoods[0]
                            }else{
                                this.$set(item.formData.tableData[i],'foodName','')//如果allfoods中的数据不为一条，将foodName赋值为空
                                // it.formData.tableData[i].foodName=''
                            }

                        // console.log("item111",item)
                    // }
                })
            },
            //小数相加
            xsadd(arg1, arg2) {
                var r1, r2, m, n;
                try {
                    r1 = arg1.toString().split(".")[1].length
                } catch (e) {
                    r1 = 0
                }
                try {
                    r2 = arg2.toString().split(".")[1].length
                } catch (e) {
                    r2 = 0
                }
                m = Math.pow(10, Math.max(r1, r2))
                n = (r1 >= r2) ? r1 : r2;
                return ((arg1 * m + arg2 * m) / m).toFixed(n);
            },
            filterNode(value,data){
                // console.log(data)
                if(!value) return true
                return  data.foodName.indexOf(value) !==-1
            },
            cpchange(e,i,index){
                let ref = eval("this.$refs.tree" + (i + index))[0]
                ref.filter(e)
            },
            cpclear(item,i,index){
                item.price=0
                let ref = eval("this.$refs.tree" + (i + index))[0]
                item.editfoods.forEach(item=>{
                    ref.setChecked(item,false,true)
                })
                item.foods=[]
                item.editfoods=[]
            },

            onSubmit(){
                this.save()
            },
            //菜品下拉
            async getFoodList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    search:''
                }
                let res = await API.getFoodList(params);
                if (res.code == 1) {

                    this.cpdata = res.data
                    // console.log('cpdata',this.cpdata)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //餐别下拉
            async getDataDict(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    type:2
                }
                let res = await API.getDataDict(params);
                if (res.code == 1) {
                    this.cbdata = res.data
                    // console.log(this.cbdata)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //食堂下拉
            async getCanteenList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                }
                let res = await API.getCanteenList(params);
                if (res.code == 1) {
                    this.ctdata = res.data
                    // console.log(this.ctdata)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            compare(beforeArr,afterArr){
                let resObj = {
                        add : [],
                        del : []
                    },
                    cenObj = {};
                //把beforeArr数组去重放入cenObj
                for(let i=0;i<beforeArr.length;i++){
                    cenObj[beforeArr[i]] = beforeArr[i];
                }
                //遍历afterArr，查看其元素是否在cenObj中
                for (let j=0;j<afterArr.length;j++){
                    if (!cenObj[afterArr[j]]){
                        resObj.add.push(afterArr[j]);
                    }else {
                        delete cenObj[afterArr[j]]
                    }
                }
                for (let k in cenObj){
                    resObj.del.push(k);
                }
                return resObj;
            },
            //菜谱保存
            async save() {
                // return
                // console.log(this.weekList)
                let alldata=[]
                this.weekList.map(it=>{
                    this.$set(it,'foodList',[])
                    if(it.formData.tableData.length>0){
                        it.formData.tableData.map(item=>{
                            this.$set(item,'newfood',[])
                            this.$set(item,'newcater',[])
                            this.$set(item,'newcanteen',[])
                            if(!!this.editData1.datePeriod){//编辑
                                if(!!item.allfoods){
                                    if(item.allfoods.length!==0){
                                        let adf=item.allfoods.filter(oitem=>!item.foodsInfo.some(item1=>oitem==item1.foodName))
                                        let delfood=item.foodsInfo.filter(oitem=>!item.allfoods.some(item1=>item1==oitem.foodName))
                                        let addfood=[]
                                        this.cpdata.forEach(iitem=>{
                                            iitem.foodList.forEach(oitem=>{
                                                adf.forEach((pitem,pindex)=>{
                                                    if(oitem.foodName==pitem){
                                                        addfood.push({
                                                            foodType:oitem.foodType,
                                                            id:oitem.id,
                                                            name:oitem.foodName,
                                                            price:oitem.price
                                                        })
                                                    }
                                                })
                                            })
                                        })
                                        let editfd=[]

                                        if(addfood.length!==0&&delfood.length!==0) {
                                            addfood.forEach(oitem => {
                                                editfd.push({
                                                    id: 0,
                                                    name: oitem.name,
                                                    obj:oitem.id,
                                                    price:oitem.price,
                                                    foodType:oitem.foodType,
                                                    pid:0,
                                                })
                                            })
                                            let shengyu=[]
                                            if(delfood.length<item.foodsInfo.length){
                                                delfood.forEach(oitem => {
                                                    shengyu = item.foodsInfo.filter(pitem => {
                                                        return pitem.id != oitem.id
                                                    })
                                                })
                                                delfood.forEach((oitem,oindex)=>{
                                                    editfd[oindex].id=oitem.id
                                                    editfd[oindex].pid=oitem.pid
                                                })
                                                editfd=[...shengyu,...editfd]
                                            }else{
                                                editfd.forEach((oitem,oindex)=>{
                                                    editfd[oindex].id=delfood[oindex].id
                                                    editfd[oindex].pid=delfood[oindex].pid
                                                })
                                            }

                                            editfd.map((caterit,caterind)=>{
                                                item.newfood.push({
                                                    foodName:caterit.name,
                                                    price:caterit.price,
                                                    id:caterit.id,
                                                    type:1,
                                                    pid:caterit.pid,
                                                    obj:caterit.obj,
                                                    foodType:caterit.foodType,
                                                })
                                            })
                                        }else if(addfood.length>0&&delfood.length==0){
                                            item.foodsInfo.forEach(oitem=>{
                                                editfd.push({
                                                    id: oitem.id,
                                                    name: oitem.foodName,
                                                    obj:oitem.obj,
                                                    price:oitem.price,
                                                    foodType:oitem.foodType,
                                                    pid:oitem.pid,
                                                })
                                            })
                                            addfood.forEach(oitem => {
                                                editfd.push({
                                                    id: 0,
                                                    name: oitem.name,
                                                    obj:oitem.id,
                                                    price:oitem.price,
                                                    foodType:oitem.foodType,
                                                    pid:0,
                                                })
                                            })
                                            editfd.map((caterit,caterind)=>{
                                                item.newfood.push({
                                                    foodName:caterit.name,
                                                    price:caterit.price,
                                                    id:0,
                                                    type:1,
                                                    pid:0,
                                                    obj:caterit.obj,
                                                    foodType:caterit.foodType,
                                                })
                                            })

                                        }else if(delfood.length>0&&addfood.length==0){
                                            editfd=JSON.parse(JSON.stringify(item.foodsInfo))
                                            // item.allcanteens=item.allcanteens.contact(delcan)
                                            for(let i =0;i<delfood.length;i++){
                                                for(let j=0;j<editfd.length;j++){
                                                    if(editfd[j].obj==delfood[i].obj){
                                                        editfd.splice(j,1)
                                                    }
                                                }
                                            }
                                            editfd.map((caterit,caterind)=>{
                                                item.newfood.push({
                                                    foodName:caterit.name,
                                                    price:caterit.price,
                                                    id:caterit.id,
                                                    type:1,
                                                    pid:caterit.pid,
                                                    obj:caterit.obj,
                                                    foodType:caterit.foodType,
                                                })
                                            })
                                        }else if(delfood.length==0&&addfood.length==0){
                                            if(item.foodsInfo.length!==0){
                                                item.foodsInfo.map((caterit,cantind)=>{
                                                    item.newfood.push({
                                                        foodName:caterit.foodName,
                                                        price:caterit.price,
                                                        id:caterit.id,
                                                        type:1,
                                                        pid:caterit.pid,
                                                        obj:caterit.obj,
                                                        foodType:caterit.foodType,
                                                    })
                                                })
                                            }else{
                                                this.cpdata.forEach(iitem=>{
                                                    iitem.foodList.forEach((oitem,pindex)=>{
                                                        item.allfoods.forEach(pitem=>{
                                                            if(oitem.foodName==pitem){
                                                                item.foodsInfo.push({
                                                                    foodType:oitem.foodType,
                                                                    id:oitem.id,
                                                                    name:oitem.foodName,
                                                                    price:oitem.price
                                                                })

                                                            }
                                                        })

                                                    })
                                                })
                                                item.foodsInfo.map((caterit,cantind)=>{
                                                    item.newfood.push({
                                                        foodName:caterit.foodName,
                                                        price:caterit.price,
                                                        id:0,
                                                        type:1,
                                                        pid:0,
                                                        obj:caterit.id,
                                                        foodType:caterit.foodType,
                                                    })
                                                })
                                            }
                                            // item.foodsInfo.map((caterit,caterind)=>{
                                            //     item.newfood.push({
                                            //         foodName:caterit.foodName,
                                            //         price:caterit.price,
                                            //         id:caterit.id,
                                            //         type:1,
                                            //         pid:caterit.pid,
                                            //         obj:caterit.obj,
                                            //         foodType:caterit.foodType,
                                            //     })
                                            // })
                                        }
                                    }else{
                                        if(item.foodsInfo.length!==0){
                                            item.foodsInfo.map((caterit,cantind)=>{
                                                item.newfood.push({
                                                    foodName:caterit.foodName,
                                                    price:caterit.price,
                                                    id:caterit.id,
                                                    type:1,
                                                    pid:caterit.pid,
                                                    obj:caterit.obj,
                                                    foodType:caterit.foodType,
                                                })
                                            })
                                        }else{
                                            this.cpdata.forEach(iitem=>{
                                                iitem.foodList.forEach((oitem,pindex)=>{
                                                    item.allfoods.forEach(pitem=>{
                                                        if(oitem.foodName==pitem){
                                                            item.foodsInfo.push({
                                                                foodType:oitem.foodType,
                                                                id:oitem.id,
                                                                name:oitem.foodName,
                                                                price:oitem.price
                                                            })

                                                        }
                                                    })

                                                })
                                            })
                                            item.foodsInfo.map((caterit,cantind)=>{
                                                item.newfood.push({
                                                    foodName:caterit.foodName,
                                                    price:caterit.price,
                                                    id:0,
                                                    type:1,
                                                    pid:0,
                                                    obj:caterit.id,
                                                    foodType:caterit.foodType,
                                                })
                                            })
                                        }
                                    }

                                }else{

                                    item.foodsInfo.map((caterit,caterind)=>{
                                        item.newfood.push({
                                            foodName:caterit.foodName,
                                            price:caterit.price,
                                            id:caterit.id,
                                            type:1,
                                            pid:caterit.pid,
                                            obj:caterit.obj,
                                            foodType:caterit.foodType,
                                        })
                                    })
                                }

                                // item.foods.map((foodit,foodind)=>{
                                //     console.log(foodit)
                                //     if ('obj'in foodit ){
                                //         this.$set(foodit,'obj',foodit.obj)//obj:菜品id
                                //     }else {
                                //         this.$set(foodit,'obj',foodit.id)
                                //         this.$set(foodit,'id',0)
                                //     }
                                //     this.$set(foodit,'type',1)
                                //     this.$set(foodit,'pid',item.id)//pid:tableid
                                //     this.$set(foodit,'id',foodit.id)
                                //     item.newfood.push(foodit)
                                // })
                                let e=[]
                                if(!!item.catering){
                                    if(item.catering.length!==0){
                                        let addcar=item.catering.filter(oitem=>!item.allcaterings.some(item1=>oitem==item1.name))
                                        let d=item.allcaterings.filter(oitem=>!item.catering.some(item1=>item1==oitem.name))
                                        this.cbdata.forEach(oitem=>{
                                            addcar.forEach((pitem,pindex)=>{
                                                if(oitem.name==pitem){
                                                    e.push({
                                                        id:oitem.id,
                                                        name:oitem.name
                                                    })
                                                }
                                            })
                                        })
                                        let editcar=[]
                                        if(e.length!==0&&d.length!==0) {
                                            e.forEach(oitem => {
                                                editcar.push({
                                                    id: 0,
                                                    name: oitem.name,
                                                    obj:oitem.id
                                                })
                                            })
                                            let shengyucar=[]
                                            if(d.length<item.allcaterings.length){
                                                d.forEach(oitem => {
                                                    shengyucar = item.allcaterings.filter(pitem => {
                                                        return pitem.id != oitem.id
                                                    })
                                                })
                                                d.forEach((oitem,oindex)=>{
                                                    editcar[oindex].id=oitem.id
                                                    editcar[oindex].pid=oitem.pid
                                                })
                                               editcar=[...shengyucar,...editcar]
                                            // }else if(d.length==item.allcaterings.length) {
                                            }else{
                                                editcar.forEach((oitem,oindex)=>{
                                                        editcar[oindex].id=d[oindex].id
                                                        editcar[oindex].pid=d[oindex].pid
                                                })
                                            }
                                            editcar.map((caterit,caterind)=>{
                                                item.newcater.push({
                                                    id:caterit.id,
                                                    type:2,
                                                    pid:item.id,
                                                    obj:caterit.obj
                                                })
                                            })
                                        }else if(e.length>0&&d.length==0){
                                            e.forEach(oitem => {
                                                item.allcaterings.push({
                                                    id:0,
                                                    name: oitem.name,
                                                    obj:oitem.id,
                                                    pid:0
                                                })
                                            })
                                            item.allcaterings.map((caterit,caterind)=>{
                                                item.newcater.push({
                                                    id:0,
                                                    type:2,
                                                    pid:0,
                                                    obj:caterit.obj
                                                })
                                            })

                                        }else if(d.length>0&&e.length==0){
                                            editcar=JSON.parse(JSON.stringify(item.allcaterings))
                                            for(let i =0;i<d.length;i++){
                                                for(let j=0;j<editcar.length;j++){
                                                    if(editcar[j].obj==d[i].obj){
                                                        editcar.splice(j,1)
                                                    }
                                                }
                                            }
                                            editcar.map((caterit,caterind)=>{
                                                item.newcater.push({
                                                    id:caterit.id,
                                                    type:2,
                                                    pid:item.id,
                                                    obj:caterit.obj
                                                })
                                            })
                                        }else if(d.length==0&&e.length==0){
                                            if(item.allcaterings.length!==0){
                                                item.allcaterings.map((cantit,cantind)=>{
                                                    item.newcater.push({
                                                        id:cantit.id,
                                                        type:2,
                                                        pid:item.id,
                                                        obj:cantit.obj
                                                    })
                                                })
                                            }else{
                                                this.cbdata.forEach(oitem=>{
                                                    item.catering.forEach((pitem,pindex)=>{
                                                        if(oitem.name==pitem){
                                                            item.allcaterings.push({
                                                                id:oitem.id,
                                                                name:oitem.name
                                                            })
                                                        }
                                                    })
                                                })
                                                item.allcaterings.map((cantit,cantind)=>{
                                                    item.newcater.push({
                                                        id:0,
                                                        type:2,
                                                        pid:0,
                                                        obj:cantit.id
                                                    })
                                                })
                                            }
                                    }
                                    }else{
                                        if(item.allcaterings.length!==0){
                                            item.allcaterings.map((cantit,cantind)=>{
                                                item.newcater.push({
                                                    id:cantit.id,
                                                    type:2,
                                                    pid:item.id,
                                                    obj:cantit.obj
                                                })
                                            })
                                        }else{
                                            this.cbdata.forEach(oitem=>{
                                                item.catering.forEach((pitem,pindex)=>{
                                                    if(oitem.name==pitem){
                                                        item.allcaterings.push({
                                                            id:oitem.id,
                                                            name:oitem.name
                                                        })

                                                    }
                                                })
                                            })
                                            item.allcaterings.map((cantit,cantind)=>{
                                                item.newcater.push({
                                                    id:0,
                                                    type:2,
                                                    pid:0,
                                                    obj:cantit.id
                                                })
                                            })
                                        }
                                    }
                                }else{
                                    item.allcaterings.map((caterit,caterind)=>{
                                        item.newcater.push({
                                            id:caterit.id,
                                            type:2,
                                            pid:item.id,
                                            obj:caterit.obj
                                        })
                                    })
                                }
                                let add=[]
                                let addcan=[]
                                let delcan=[]
                                if(!!item.canteen){
                                    if(item.canteen.length!==0){
                                        add=item.canteen.filter(oitem=>!item.allcanteens.some(item1=>oitem==item1.name))
                                        delcan=item.allcanteens.filter(oitem=>!item.canteen.some(item1=>item1==oitem.name))
                                        this.ctdata.forEach(oitem=>{
                                            add.forEach((pitem,pindex)=>{
                                                if(oitem.canteenName==pitem){
                                                    addcan.push({
                                                        id:oitem.canteen,
                                                        name:oitem.canteenName
                                                    })

                                                }
                                            })
                                        })
                                        let editcan=[]
                                        if(addcan.length!==0&&delcan.length!==0){
                                            addcan.forEach(oitem=>{
                                                editcan.push({
                                                    id:0,
                                                    name:oitem.name,
                                                    obj:oitem.id
                                                })
                                            })

                                            let shengyucan=[]
                                            if(delcan.length<item.allcanteens.length){
                                                delcan.forEach(oitem=>{
                                                    shengyucan=item.allcanteens.filter(pitem=>{
                                                        return pitem.id!=oitem.id
                                                    })
                                                })
                                                delcan.forEach((oitem,oindex)=>{

                                                    editcan[oindex].id=oitem.id
                                                    editcan[oindex].pid=oitem.pid
                                                })
                                                editcan=[...shengyucan,...editcan]

                                            }else{
                                                editcan.forEach((oitem,oindex)=>{
                                                    editcan[oindex].id=delcan[oindex].id
                                                    editcan[oindex].pid=delcan[oindex].pid
                                                })
                                            }
                                            editcan.map((cantit,cantind)=>{
                                                item.newcanteen.push({
                                                    id:cantit.id,
                                                    type:3,
                                                    pid:item.id,
                                                    obj:cantit.obj
                                                })
                                            })
                                        }else if(addcan.length>0&&delcan.length==0){

                                            addcan.forEach(oitem=>{
                                                item.allcanteens.push({
                                                    id:0,
                                                    name:oitem.name,
                                                    obj:oitem.id
                                                })
                                            })

                                            item.allcanteens.map((cantit,cantind)=>{
                                                item.newcanteen.push({
                                                    id:cantit.id,
                                                    type:3,
                                                    pid:item.id,
                                                    obj:cantit.obj
                                                })
                                            })
                                        }else if(addcan.length==0&&delcan.length>0){
                                            editcan=JSON.parse(JSON.stringify(item.allcanteens))
                                            // item.allcanteens=item.allcanteens.contact(delcan)
                                            for(let i =0;i<delcan.length;i++){
                                                for(let j=0;j<editcan.length;j++){
                                                    if(editcan[j].obj==delcan[i].obj){
                                                        editcan.splice(j,1)
                                                    }
                                                }
                                            }

                                            editcan.map((cantit,cantind)=>{
                                                item.newcanteen.push({
                                                    id:cantit.id,
                                                    type:3,
                                                    pid:item.id,
                                                    obj:cantit.obj
                                                })
                                            })
                                        }else if(addcan.length==0&&delcan.length==0){
                                            if(item.allcanteens.length!==0){
                                                item.allcanteens.map((cantit,cantind)=>{
                                                    item.newcanteen.push({
                                                        id:cantit.id,
                                                        type:3,
                                                        pid:item.id,
                                                        obj:cantit.obj
                                                    })
                                                })
                                            }else{
                                                this.ctdata.forEach(oitem=>{
                                                    item.canteen.forEach((pitem,pindex)=>{
                                                        if(oitem.name==pitem){
                                                            item.allcanteens.push({
                                                                id:oitem.canteen,
                                                                name:oitem.canteenName
                                                            })

                                                        }
                                                    })
                                                })
                                                item.allcanteens.map((cantit,cantind)=>{
                                                    item.newcanteen.push({
                                                        id:0,
                                                        type:3,
                                                        pid:0,
                                                        obj:cantit.id
                                                    })
                                                })
                                            }
                                        }
                                    }else{
                                        if(item.allcanteens.length!==0){
                                            item.allcanteens.map((cantit,cantind)=>{
                                                item.newcanteen.push({
                                                    id:cantit.id,
                                                    type:3,
                                                    pid:item.id,
                                                    obj:cantit.obj
                                                })
                                            })
                                        }else{
                                            this.ctdata.forEach(oitem=>{
                                                item.canteen.forEach((pitem,pindex)=>{
                                                    if(oitem.name==pitem){
                                                        item.allcanteens.push({
                                                            id:oitem.canteen,
                                                            name:oitem.canteenName
                                                        })

                                                    }
                                                })
                                            })
                                            item.allcanteens.map((cantit,cantind)=>{
                                                item.newcanteen.push({
                                                    id:0,
                                                    type:3,
                                                    pid:0,
                                                    obj:cantit.id
                                                })
                                            })
                                        }
                                    }
                                }else{
                                    item.allcanteens.map((caterit,caterind)=>{
                                        item.newcanteen.push({
                                            id:caterit.id,
                                            type:3,
                                            pid:item.id,
                                            obj:caterit.obj
                                        })
                                    })
                                }
                            }else{//新增
                                item.foods.map((foodit,foodind)=>{
                                    item.newfood.push({
                                        foodName:foodit.foodName,
                                        foodType:foodit.foodType,
                                        price:foodit.price,
                                        id:0,
                                        type:1,
                                        pid:0,
                                        obj:foodit.id
                                    })
                                })
                                item.catering.map((cater,caterind)=>{
                                    item.newcater.push({
                                        id:0,
                                        type:2,
                                        pid:item.id,
                                        obj:cater
                                    })
                                })
                                item.canteen.map((cant,cantind)=>{
                                    item.newcanteen.push({
                                        id:0,
                                        type:3,
                                        pid:item.id,
                                        obj:cant
                                    })
                                })
                            }
                            it.foodList.push({
                                foodName:item.foodName,
                                disPrice:item.disPrice==0?null:item.disPrice,
                                foodId:item.newfood.length==1?item.newfood[0].obj:'',
                                // price:item.disPrice,
                                originalPrice:item.price,
                                refundTimeout:item.refundTimeout,
                                // flag:item.allfoods.length > 1?0:item.foods[0].foodType,
                                flag:item.allfoods.length > 1?0:item.allfoods.length == 1?item.foods[0].foodType:'',//菜单下拉
                                // fileId:item.foods[0].fileId,
                                childList:[...item.newfood,...item.newcater,...item.newcanteen],
                                date:it.day,
                                qtyControl:item.qtyControl,
                                remainQty:item.remainQty,
                                // foods:item.foods,
                                // catering:item.catering,
                                // canteen:item.canteen,
                                id:item.id==0?'':item.id,
                                // pid:item.pid
                            })

                        })
                    }

                })
                // console.log(this.weekList)
// return
                this.weekList.map(it=>{
                    alldata.push({
                        data:it.foodList
                    })
                    // this.$set(alldata,'date',it.day)
                    // this.$set(alldata,'data',it.foodList)
                })
                // console.log(this.weekList)
                let count=0

                this.weekList.map(item=>{
                    if(item.foodList.length==0){
                        count++
                    }
                })

                //表单验证
                if(count==this.weekList.length){
                    this.$message.error('请新增一天菜品后保存');
                    return
                }

                for(let i =0;i<this.weekList.length;i++){
                    let item=this.weekList[i]
                    if(item.foodList.length!==0){
                        for(let j =0;j<item.foodList.length;j++) {
                            let it=item.foodList[j]
                            if(!it.foodName){
                                this.$message.error('请输入菜品名称后保存');
                                return
                            }
                            let a=it.childList.some(item=>item.type==1)
                            let b=it.childList.some(item=>item.type==2)
                            let c=it.childList.some(item=>item.type==3)
                            if(a==false){
                                this.$message.error('请选择菜品后保存');
                                return
                            }
                            if(b==false){
                                this.$message.error('请选择餐别后保存');
                                return
                            }
                            if(c==false){
                                this.$message.error('请选择食堂后保存');
                                return
                            }
                        }

                    }

                }
                //详情数据
                let iddata=[]
                let a=[]
                let ceshi=[]
                let oiddata=[]
                if(!!this.editData1.datePeriod){
                    iddata=JSON.parse(JSON.stringify(alldata))
                    a=JSON.parse(JSON.stringify(alldata))
                    // console.log('a',a)
                    for(let i=0;i<iddata.length;i++){
                        for(let j=0;j<iddata[i].data.length;j++) {
                            if (iddata[i].data[j].id == '') {
                                iddata[i].data.splice(j, 1)
                                j--
                            }
                        }
                    }
                    for(let i=0;i<a.length;i++){
                        for(let j=0;j<a[i].data.length;j++) {
                            if (a[i].data[j].id != '') {
                                a[i].data.splice(j, 1)
                                j--
                            }
                        }
                    }

                    // }

                    // console.log(this.oldTable)
                    // console.log('delall',this.delall)
                    this.oldTable.filter((item,index)=>{
                        item.formData.tableData.map((it,index1)=>{
                            this.delall.map(itt=>{
                                if(it.id==itt){
                                    item.formData.tableData.splice(index1,1)
                                    // index1--
                                }
                            })
                        })

                    })
                    this.oldTable.map(it=>{
                        this.$set(it,'foodList',[])
                        it.formData.tableData.map(oitem=>{
                            this.$set(oitem,'newfood',[])
                            this.$set(oitem,'newcater',[])
                            this.$set(oitem,'newcanteen',[])
                            oitem.catering=[]
                            oitem.canteen=[]

                            oitem.allcanteens.map(allcan=>{
                                oitem.canteen.push({
                                    id:allcan.id,
                                    pid:allcan.pid,
                                    obj:allcan.obj
                                })
                            })
                            oitem.allcaterings.map(allcat=>{
                                oitem.catering.push({
                                    id:allcat.id,
                                    pid:allcat.pid,
                                    obj:allcat.obj
                                })
                            })
                            // console.log("22",item.foods)
                            oitem.foods.map((foodit,foodind)=>{
                                oitem.newfood.push({
                                    foodName:foodit.foodName,
                                    price:foodit.price,
                                    id:foodit.id,
                                    type:1,
                                    pid:oitem.id,
                                    obj:foodit.obj,
                                    foodType:foodit.foodType
                                })
                                // this.$set(foodit,'type',1)
                                // this.$set(foodit,'pid',oitem.id)
                                // this.$set(foodit,'obj',foodit.obj)
                                // oitem.newfood.push(foodit)
                            })
                            oitem.catering.map((caterit,caterind)=>{
                                oitem.newcater.push({
                                    id:caterit.id,
                                    type:2,
                                    pid:caterit.pid,
                                    obj:caterit.obj,
                                })

                            })
                            oitem.canteen.map((cantit,cantind)=>{
                                oitem.newcanteen.push({
                                    id:cantit.id,
                                    type:3,
                                    pid:cantit.pid,
                                    obj:cantit.obj,
                                })
                            })
                            it.foodList.push({
                                foodName:oitem.foodName,
                                disPrice:oitem.disPrice==0?null:oitem.disPrice,//售价
                                foodId:oitem.newfood.length==1?oitem.newfood[0].obj:'',
                                originalPrice:oitem.price,//原价
                                refundTimeout:oitem.refundTimeout,
                                // flag:item.allfoods.length > 1?0:item.foods[0].foodType,
                                flag:oitem.allfoods.length > 1?0:oitem.allfoods.length == 1?oitem.foods[0].foodType:'',//菜单下拉
                                // fileId:item.foods[0].fileId,
                                childList:[...oitem.newfood,...oitem.newcater,...oitem.newcanteen],
                                date:it.day,
                                qtyControl:oitem.qtyControl,
                                remainQty:oitem.remainQty,
                                // foods:item.foods,
                                // catering:item.catering,
                                // canteen:item.canteen,
                                id:oitem.id==0?'':oitem.id,
                                // pid:item.pid
                            })
                            // console.log('newcanteen22222',item.newcanteen)
                            // console.log("foodList",it.foodList)
                        })
                        oiddata.push({
                            data:it.foodList
                        })
                        // console.log("oiddata",oiddata)
                    })
                    // console.log(this.oldTable)
                    // return
                    // for(let i=0;i<iddata.length;i++) {
                    //     if(iddata[i].data.length==0){
                    //         iddata.splice(i,1)
                    //         i--
                    //     }
                    // }
                    iddata.forEach(iditem=>{
                        iditem.data.forEach(ooitem=>{
                            ooitem.disPrice=ooitem.disPrice-0
                            ooitem.originalPrice=ooitem.originalPrice-0
                        })
                    })
                    // console.log(iddata)
                    // console.log(oiddata)
                    oiddata.forEach((item,index)=>{
                        item.data.map((it,sindex)=>{
                            // console.log(JSON.stringify(it)!=JSON.stringify(iddata[index].data[sindex]))
                            // console.log(index,sindex)
                            // console.log(JSON.stringify(it.date)!=JSON.stringify(iddata[index].data[sindex].date))
                            // console.log(JSON.stringify(it.refundTimeout)!=JSON.stringify(iddata[index].data[sindex].refundTimeout))
                            // console.log(JSON.stringify(it.flag)!=JSON.stringify(iddata[index].data[sindex].flag))
                            // console.log(JSON.stringify(it.disPrice)!=JSON.stringify(iddata[index].data[sindex].disPrice))
                            // console.log(JSON.stringify(it.childList[0])!=JSON.stringify(iddata[index].data[sindex].childList[0]))
                            // console.log(JSON.stringify(it.childList[1])!=JSON.stringify(iddata[index].data[sindex].childList[1]))
                            // console.log(JSON.stringify(it.childList[2])!=JSON.stringify(iddata[index].data[sindex].childList[2]))
                            // console.log(JSON.stringify(it.childList[3])!=JSON.stringify(iddata[index].data[sindex].childList[3]))
                            // console.log(JSON.stringify(it.foodName)!=JSON.stringify(iddata[index].data[sindex].foodName))
                            // console.log(JSON.stringify(it.foodId)!=JSON.stringify(iddata[index].data[sindex].foodId))
                            // console.log(JSON.stringify(it.qtyControl)!=JSON.stringify(iddata[index].data[sindex].qtyControl))
                            // console.log(JSON.stringify(it.id)!=JSON.stringify(iddata[index].data[sindex].id))
                            if(JSON.stringify(it)!=JSON.stringify(iddata[index].data[sindex])&&!!iddata[index].data[sindex]){
                                // console.log(it,1)
                                // console.log(iddata[index].data[sindex],2)
                                // it.foods=iddata[index].data[sindex].foods
                                // it.catering=iddata[index].data[sindex].catering
                                // it.canteen=iddata[index].data[sindex].canteen
                                it.refundTimeout=iddata[index].data[sindex].refundTimeout
                                it.date=iddata[index].data[sindex].date
                                it.foodId=iddata[index].data[sindex].foodId
                                it.flag=iddata[index].data[sindex].flag
                                it.disPrice=iddata[index].data[sindex].disPrice
                                it.childList=iddata[index].data[sindex].childList
                                it.foodName=iddata[index].data[sindex].foodName
                                it.qtyControl=iddata[index].data[sindex].qtyControl
                                // it.pid=iddata[index].data[sindex].pid
                                it.id=iddata[index].data[sindex].id

                               ceshi.push(it)
                            }



                        })
                    })
                    for(let i =0;i<a.length;i++){
                        if(a[i].data.length==0){
                            a.splice(i,1)
                            i--
                        }
                    }
                }
                let b =[]
                alldata.map((item,index)=>{
                    item.data.map(it=>{
                        b.push(it)

                    })

                })
                let c=[]
                if(this.editbtn==3){
                    if(a.length==0&&ceshi.length==0){
                        c=[]
                    }else if(a.length>0&&ceshi.length==0){
                        a.map((item,index)=>{
                            item.data.forEach(it=>{
                                c.push(it)

                            })
                        })
                    }else if(a.length>0&&ceshi.length>0){
                        ceshi.forEach(item=>{
                            c.push(item)
                        })
                        a.map((item,index)=>{
                            item.data.forEach(it=>{
                                c.push(it)

                            })
                        })
                    }else{
                        ceshi.forEach(item=>{
                            c.push(item)
                        })
                    }
                }
                // this.isDisable=true
                if(ceshi.length==0&&a.length==0&&this.editbtn==3&&this.delall.length==0){
                    this.isDisable=false

                    this.$message.error('当前菜谱没有任何修改');
                    return
            }
            this.isDisable=false
                // console.log(b)
                // console.log(c)
                // return
                let params = {
                    // status:!this.editData1.date?'insert':'update',
                    // date:this.formData.createTime,
                    foodList:!this.editData1.datePeriod?b:c,
                    deleteCookBook:this.delall,
                    // deleteCookBookChild:
                }

                let res = await API.save(params);
                if (res.code == 1) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit("close")
                    this.$emit("getList")
                    this.isDisable=false
                } else if (res.code == -2) {
                    this.shibai=2
                    this.isDisable=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.shibai=2

                    this.isDisable=false
                    this.saveButton=false
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
        /deep/.ceshic .el-select--mini{
            width: 100%;
        }
        .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
            background-color: #FFFFFF;
        }
        .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
            background-color: #FFFFFF;
        }
        .el-select-dropdown__item.selected {
            font-weight: normal;
        }
        .el-form-item__error{
            margin-left: -30px;
        }
    }

    .upload-box img{
        width: 80px !important;
        height: 80px !important;
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    /*11111111111*/
    .mrr2{
        margin-right: 2px;
    }
    .img-box{
        /*border: 1px solid red;*/
        .uploadPhone{
            width: 70px;
            height: 80px;
            position: relative;
            width: 100px;
            padding-left: 50px;
            /*border: 1px solid cornflowerblue;*/
        }
        .uploadPhone .img{
            width: 80px;
            height: 80px;
            margin-right: 5px;
        }
        .elimg{
            width:105px
        }
        .el-icon-delete{
            padding-right: 5px;
        }

        /*.uploadPhone video{*/
        /*    width: 100px;*/
        /*    height: 80px;*/
        /*}*/

        .upload-box{
            /*background: red;*/
            width: 100%;
            height: 100%;
        }
        .upload-input{
            position: absolute;
            opacity: 0;
            width: 80px;
            height: 80px;
        }
    }
    .flex{
        display: flex;
    }
    .flex1{
        display: flex;
    }
    /*1111111111*/
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.is-active{
        line-height: inherit !important;
        height: inherit !important;
    }
    /deep/.is-top{
        /*width: 100%;*/
        flex:1;
        line-height: inherit !important;
        height: inherit !important;
        padding: 0;
    }
    /deep/.el-tabs__nav{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    /deep/.is-top:nth-child(2){
        padding-left: 0 !important;
    }
    /deep/.is-top:last-child{
        padding-right: 0 !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
    /deep/.el-form-item__content{
        margin-left: 0px !important;
    }
</style>